<template>
  <div class="col-12">
    <AppHeading>Data Seeding</AppHeading>
    <p>
      The following functionality is used to seed your coursedog account with default data.
      Be aware, any seeding action could overwrite existing data.
    </p>
    <div v-if="userRoles.includes('coursedog')" class="card border-0">
      <div class="card-header">
        <AppHeading>Sandbox Data</AppHeading>
        <p>
          Use this to seed this account with sandbox data for all products
        </p>
      </div>

      <div class="card-body">

        <div class="row">
          <div class="col ">
            <AppButton @click="openModal('PopulateDataModal', {
              school: schoolName || '',
              products: [ 'scheduling' ],
            })">
              Populate
            </AppButton>
          </div>
        </div>
      </div>

    </div>
    <div class="card border-0">
      <div class="card-header">
        <AppHeading>Catalog Pages</AppHeading>
        <p>
          Use this to seed a specific catalog with the following pre-built pages: Home, Courses, Departments, and Programs.
        </p>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col">
            <FormSelect
              label="Select Catalog"
              placeholder="Select an existing catalog"
              :config="{options: catalogSelectOptions}"
              :value="selectedCatalogId"
              :custom-label="getCatalogDisplayName"
              @input="selectedCatalogId = $event"
            />
          </div>
          <div class="col mt-4">
            <AppButtonAsync
              :raised="true"
              :disabled="!selectedCatalogId || catalogSeeded"
              :promise="seedCatalogPages"
            >
              Seed Catalog
            </AppbuttonAsync>
          </div>
        </div>
      </div>
    </div>
    <component
      :is="currentModal.component"
      :data="currentModal.data"
      @close="closeModal"
      @showSnackbar="showSnackbar"
    />
  </div>
</template>

<script>
import FormSelect from '@/components/Forms/FormSelect'
import { mapGetters } from 'vuex'
import { getCatalogs, seedCatalogPages } from '@/api'
import PopulateDataModal from '@/components/Admin/PopulateDataModal'
import { modalMixin } from '@/mixins/modal'

export default {
  mixins: [ modalMixin ],
  components: {
    FormSelect,
    PopulateDataModal,
  },
  props: {
    school: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      selectedCatalogId: null,
      catalogs: [],
      isLoading: true,
      catalogSeeded: false,
    }
  },
  computed: {
    ...mapGetters([
      'userRoles',
    ]),
    catalogSelectOptions () {
      return this.catalogs.map(({ id }) => id)
    },
    schoolName () {
      return this.school.databaseName
    },
  },
  async created () {
    this.isLoading = true
    await this.fetchCatalogs()
    this.isLoading = false
  },
  methods: {
    async seedCatalogPages () {
      if (!this.selectedCatalogId) return
      await seedCatalogPages({ school: this.schoolName, catalogId: this.selectedCatalogId })
      this.catalogSeeded = true
      this.$store.dispatch('ui/showSnackbar', { text: 'Catalog Seeded Successfully' })
    },
    async fetchCatalogs () {
      this.catalogs = await getCatalogs({ school: this.schoolName }) || {}
    },
    showSnackbar (text) {
      this.$store.dispatch('ui/showSnackbar', { text })
    },
    getCatalogDisplayName (catalogId) {
      const catalog = this.catalogs.find(catalog => catalogId === catalog.id)

      return catalog ? catalog.displayName : catalogId
    },
  },
}
</script>

<style scoped>

.row {
  margin-bottom: 1rem;
}

</style>
